import { tableColumns } from './tableColumns';
export { dayOfWeek, daysOfWeek } from './dayOfWeek';
export * from './orderStatus';

export const constants = {
  ...tableColumns,
};
